var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c(
      "div",
      { staticClass: "contents_wrap" },
      [
        _vm.$route.name !== "newQuestionConnect"
          ? _c(
              "fragment",
              [
                _c("skp-breadcrumbs", {
                  on: {
                    "page-title": function(val) {
                      return (_vm.pageTitle = val)
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$route.name === "newQuestionConnect"
          ? _c("h2", { staticClass: "pg_title" }, [
              _vm._v(_vm._s(_vm.$t("TITLE.CREATE.NEW.QUESTION")))
            ])
          : _c("h2", { staticClass: "pg_title" }, [
              _vm._v(_vm._s(_vm.pageTitle))
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "srchTop_wrap srchFaq_wrap extend" }, [
          _c("article", { staticClass: "srch_basic" }, [
            "C550" === _vm.corpCd || "WA" === _vm.corpCd
              ? _c("dl", { staticClass: "dl_search set_2" }, [
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchTitle,
                            expression: "searchTitle"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("BUTTON.GLOBAL.SEARCH")
                        },
                        domProps: { value: _vm.searchTitle },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchTitle = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchKeyword,
                            expression: "searchKeyword"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("FIELD.GLOBAL.SEARCHKEYWORD")
                        },
                        domProps: { value: _vm.searchKeyword },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchKeyword = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("dd", { staticClass: "btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_srch",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.search(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                    )
                  ])
                ])
              : _c("dl", { staticClass: "dl_search" }, [
                  _c(
                    "dd",
                    {
                      staticClass: "clearable",
                      attrs: { "data-input-type": "input" }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchTitle,
                            expression: "searchTitle"
                          },
                          { name: "clearable", rawName: "v-clearable" }
                        ],
                        staticClass: "text_input w100p",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t("BUTTON.GLOBAL.SEARCH")
                        },
                        domProps: { value: _vm.searchTitle },
                        on: {
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.stopPropagation()
                            return _vm.search(1)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchTitle = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("dd", { staticClass: "btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_srch",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.search(1)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SEARCH")))]
                    )
                  ])
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "top_mobile" }, [
              _c("div", { staticClass: "mobile_title" }, [
                _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.category1Code,
                          expression: "category1Code"
                        }
                      ],
                      staticClass: "slt_white w100p",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.category1Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.categoryList(2)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.category1CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.faqPageName + item.code,
                            domProps: { value: item.code }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.codeName) +
                                "\n                                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c("dl", { staticClass: "dl_select" }, [
                _c("dd", { attrs: { "data-input-type": "select" } }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.category2Code,
                          expression: "category2Code"
                        }
                      ],
                      staticClass: "slt_white w100p",
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.category2Code = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.categoryList(3)
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.category2CodeList, function(item) {
                        return _c(
                          "option",
                          {
                            key: _vm.faqPageName + item.code,
                            domProps: { value: item.code }
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.codeName) +
                                "\n                                "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("article", { staticClass: "srch_detail" }, [
            _c("div", { staticClass: "list_wrap" }, [
              _c("header", [
                _c("h3", [_vm._v(_vm._s(_vm.$t("FIELD.FAQ.CATEGORY.QUICK")))])
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "ul_list" },
                _vm._l(_vm.supportSnb.faqQuickCategoryLAist, function(item) {
                  return _c(
                    "li",
                    {
                      key:
                        _vm.faqPageName +
                        item.WORK_KEY_1 +
                        item.WORK_KEY_2 +
                        item.WORK_KEY_3 +
                        item.ROW_NUM
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.getQuickCategoryClick(
                                item.WORK_KEY_1,
                                item.WORK_KEY_2,
                                item.WORK_KEY_3
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.getQuickName(
                                  item.WORK_KEY_1_NM,
                                  item.WORK_KEY_2_NM,
                                  item.WORK_KEY_3_NM
                                )
                              ) +
                              "\n                            "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c(
              "dl",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.open,
                    expression: "open"
                  }
                ],
                staticClass: "dl_input"
              },
              [
                _c("dt", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))]),
                _vm._v(" "),
                _c("dd", { attrs: { "data-input-type": "date" } }, [
                  _c("fieldset", { staticClass: "ui_fieldset" }, [
                    _c("span", { staticClass: "date-wrap" }, [
                      _c("label", [
                        _c("input", {
                          staticClass: "date_input w100p",
                          attrs: {
                            id: "frDate",
                            type: "text",
                            placeholder: "MM.DD.YYYY",
                            readonly: "",
                            maxlength: "20"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "in_btn",
                            attrs: { href: "javascript:", id: "icoFrDate" }
                          },
                          [
                            _c("i", { staticClass: "ico_date" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr_only" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "fr_datepicker",
                        attrs: { id: "fr-picker-container" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("em", { staticClass: "txt_space" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "date-wrap" }, [
                      _c("label", [
                        _c("input", {
                          staticClass: "date_input w100p",
                          attrs: {
                            id: "toDate",
                            type: "text",
                            placeholder: "MM.DD.YYYY",
                            readonly: "",
                            maxlength: "20"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "in_btn",
                            attrs: { href: "javascript:", id: "icoToDate" }
                          },
                          [
                            _c("i", { staticClass: "ico_date" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "sr_only" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.DATE")))
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "to_datepicker",
                        attrs: { id: "to-picker-container" }
                      })
                    ])
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn_ico_srchBtm",
              attrs: { href: "javascript:", title: "Fold" },
              on: {
                click: function($event) {
                  return _vm.srchBtmClick($event)
                }
              }
            },
            [_c("span", { staticClass: "sr_only" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inquiry_wrap" }, [
          _c(
            "ul",
            { staticClass: "ul_list list_03" },
            _vm._l(_vm.supportSnb.faqInquiry, function(item, idx) {
              return _c(
                "li",
                {
                  key: _vm.qnaPageName + item.INQUIRY_TYPE1 + idx + "mobile",
                  class: _vm.getSnbClass(item.INQUIRY_TYPE1)
                },
                [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:" },
                      on: {
                        click: function($event) {
                          return _vm.snbClick(
                            $event,
                            item.INQUIRY_TYPE1,
                            "",
                            ""
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(item.INQUIRY_TYPE_NM1)
                      ),
                      item.TOTAL_CNT
                        ? _c("em", [_vm._v("(" + _vm._s(item.TOTAL_CNT) + ")")])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  !(
                    "ALL" === item.INQUIRY_TYPE1 || "ETC" === item.INQUIRY_TYPE1
                  )
                    ? _c(
                        "a",
                        {
                          staticClass: "ico_arrow",
                          attrs: { href: "javascript:" },
                          on: {
                            click: function($event) {
                              return _vm.snbClick(
                                $event,
                                item.INQUIRY_TYPE1,
                                "",
                                "arrow"
                              )
                            }
                          }
                        },
                        [_c("span", { staticClass: "sr_only" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !(
                    "ALL" === item.INQUIRY_TYPE1 || "ETC" === item.INQUIRY_TYPE1
                  )
                    ? _c(
                        "ul",
                        _vm._l(_vm.supportSnb.faqSubInquiry, function(
                          itemSub,
                          idxSub
                        ) {
                          return _c(
                            "li",
                            {
                              key:
                                _vm.qnaPageName +
                                itemSub.INQUIRY_TYPE1 +
                                idxSub +
                                "mobile",
                              on: {
                                click: function($event) {
                                  return _vm.snbClick(
                                    $event,
                                    item.INQUIRY_TYPE1,
                                    itemSub.INQUIRY_TYPE2,
                                    ""
                                  )
                                }
                              }
                            },
                            [
                              _c("a", { attrs: { href: "javascript:" } }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(itemSub.INQUIRY_TYPE_NM2) +
                                    "\n                                "
                                ),
                                itemSub.TOTAL_CNT
                                  ? _c("em", [
                                      _vm._v(
                                        "(" + _vm._s(itemSub.TOTAL_CNT) + ")"
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tab_wrap" }, [
          _vm.$route.name === "newQuestionConnect"
            ? _c("div", { staticClass: "tab_btn" }, [
                _c(
                  "em",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.viewYn,
                        expression: "!viewYn"
                      }
                    ],
                    staticClass: "em_info"
                  },
                  [_vm._v(_vm._s(_vm.$t("MESSAGE.DATA.NEWQUESTION.CONFIRM")))]
                ),
                _vm._v(" "),
                !_vm.getIsMobile &&
                _vm.searchYn &&
                ((0 === _vm.qnaTotalRecords &&
                  0 === _vm.faqTotalRecords &&
                  _vm.searchYn) ||
                  _vm.viewYn)
                  ? _c(
                      "a",
                      {
                        staticClass: "txt_link",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.createNewQuestionPopup()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("MESSAGE.FAQ.CREATE")) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _c("div", { staticClass: "tab_btn" }, [
                _vm.isSurvey
                  ? _c("em", { staticClass: "em_info" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.DATA.NOTQUESTION.CONFIRM")))
                    ])
                  : _c(
                      "em",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.viewYn,
                            expression: "!viewYn"
                          }
                        ],
                        staticClass: "em_info"
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.DATA.NEWQUESTION.CONFIRM"))
                        )
                      ]
                    ),
                _vm._v(" "),
                !_vm.getIsMobile &&
                _vm.searchYn &&
                ((0 === _vm.qnaTotalRecords &&
                  0 === _vm.faqTotalRecords &&
                  _vm.searchYn) ||
                  _vm.viewYn)
                  ? _c(
                      "a",
                      {
                        staticClass: "txt_link",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            return _vm.register()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("MESSAGE.FAQ.CREATE")) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
          _vm._v(" "),
          _c("ul", { staticClass: "tab_menu_04 tab_menus" }, [
            _c(
              "li",
              {
                staticClass: "on",
                attrs: { id: "tab_faq" },
                on: {
                  click: function($event) {
                    return _vm.tabClick($event, "faq")
                  }
                }
              },
              [
                _c("a", { attrs: { href: "javascript:" } }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.FAQ")) +
                      "\n                        "
                  ),
                  _c("em", { staticClass: "count" }, [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.faqTotalRecords === -1 ? 0 : _vm.faqTotalRecords
                        ) +
                        ")"
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                attrs: { id: "tab_qna" },
                on: {
                  click: function($event) {
                    return _vm.tabClick($event, "qna")
                  }
                }
              },
              [
                _c("a", { attrs: { href: "javascript:" } }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("FIELD.GLOBAL.QNA")) +
                      "\n                        "
                  ),
                  _c("em", { staticClass: "count" }, [
                    _vm._v(
                      "(" +
                        _vm._s(
                          _vm.qnaTotalRecords === -1 ? 0 : _vm.qnaTotalRecords
                        ) +
                        ")"
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tab_contents" }, [
            _c("div", { staticClass: "tab_cont faq" }, [
              0 < _vm.faqList.length
                ? _c("div", { staticClass: "faq_wrap" }, [
                    _c(
                      "ul",
                      { staticClass: "faq_list" },
                      _vm._l(_vm.faqList, function(item) {
                        return _c(
                          "li",
                          {
                            key: _vm.faqPageName + item.FAQ_ID,
                            class: item.GRADE === "S" ? "important" : ""
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ico_faq_q",
                                on: {
                                  click: function($event) {
                                    return _vm.faqClick($event, item.FAQ_ID)
                                  }
                                }
                              },
                              [
                                "S" === item.GRADE
                                  ? _c(
                                      "em",
                                      { staticClass: "textcolor_important" },
                                      [
                                        _vm._v(
                                          "\n                                        [" +
                                            _vm._s(
                                              _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                            ) +
                                            "]\n                                    "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.TITLE) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "ico_faq_a" }, [
                              _c("div", { staticClass: "q_cont" }, [
                                _c("div", {
                                  staticClass: "namo_scrollbar",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.stripHtml(item.QUESTION_DESC)
                                    )
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              item.SOLUTION_DESC
                                ? _c(
                                    "div",
                                    { staticClass: "a_cont" },
                                    [
                                      _c("div", {
                                        staticClass: "namo_scrollbar",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.stripHtml(item.SOLUTION_DESC)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.faqAttach, function(file) {
                                        return _c(
                                          "span",
                                          {
                                            key:
                                              file.ENC_ATTCH_FILE_SEQ +
                                              file.ENC_TOKEN
                                          },
                                          [
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "txt_link",
                                                attrs: {
                                                  href: _vm.getDownloadUrl(
                                                    file.ENC_ATTCH_FILE_SEQ,
                                                    file.ENC_TOKEN
                                                  ),
                                                  download: "true",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(file.FILE_NM) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.$route.name !== "newQuestionConnect"
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _vm.faqCurrentRecords < _vm.faqTotalRecords
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn_laodmore",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.search(0)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("BUTTON.SEARCH.LOAD.MORE")
                                      ) +
                                      "\n                                "
                                  ),
                                  _c("em", [
                                    _vm._v(
                                      "\n                                    ("
                                    ),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.faqCurrentRecords))
                                    ]),
                                    _vm._v(
                                      " / " +
                                        _vm._s(_vm.faqTotalRecords) +
                                        ")\n                                "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.getIsMobile &&
                          _vm.searchYn &&
                          ((0 === _vm.faqTotalRecords && _vm.searchYn) ||
                            _vm.viewYn)
                            ? _c(
                                "a",
                                {
                                  staticClass: "txt_link",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.register()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("MESSAGE.FAQ.CREATE")) +
                                      "\n                            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "faq_wrap" }, [
                    _c("ul", { staticClass: "faq_list" }, [
                      _c("li", { staticClass: "nodata" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                        ])
                      ])
                    ])
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tab_cont qna" }, [
              0 < _vm.qnaList.length
                ? _c("div", { staticClass: "faq_wrap" }, [
                    _c(
                      "ul",
                      { staticClass: "faq_list" },
                      _vm._l(_vm.qnaList, function(item) {
                        return _c(
                          "li",
                          {
                            key: _vm.qnaPageName + item.QUESTION_ID,
                            class: item.GRADE === "S" ? "important" : ""
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "ico_faq_q",
                                on: {
                                  click: function($event) {
                                    return _vm.qnaClick(
                                      $event,
                                      item.QUESTION_ID
                                    )
                                  }
                                }
                              },
                              [
                                "Y" === item.URGENT_YN
                                  ? _c(
                                      "em",
                                      { staticClass: "textcolor_important" },
                                      [
                                        _vm._v(
                                          "\n                                        [" +
                                            _vm._s(
                                              _vm.$t("FIELD.GLOBAL.IMPORTANT")
                                            ) +
                                            "]\n                                    "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(item.TITLE) +
                                    "\n                                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "ico_faq_a" }, [
                              _c("div", { staticClass: "q_cont" }, [
                                _c("div", {
                                  staticClass: "namo_scrollbar",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.stripHtml(item.QUESTION_DESC)
                                    )
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              item.SOLUTION_DESC
                                ? _c(
                                    "div",
                                    { staticClass: "a_cont" },
                                    [
                                      _c("div", {
                                        staticClass: "namo_scrollbar",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.stripHtml(item.SOLUTION_DESC)
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(_vm.qnaAttach, function(file) {
                                        return _c(
                                          "span",
                                          {
                                            key:
                                              file.ENC_ATTCH_FILE_SEQ +
                                              file.ENC_TOKEN
                                          },
                                          [
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass: "txt_link",
                                                attrs: {
                                                  href: _vm.getDownloadUrl(
                                                    file.ENC_ATTCH_FILE_SEQ,
                                                    file.ENC_TOKEN
                                                  ),
                                                  download: "true",
                                                  target: "_blank"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(file.FILE_NM) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.$route.name !== "newQuestionConnect"
                      ? _c("div", { staticClass: "btn_wrap" }, [
                          _vm.qnaCurrentRecords < _vm.qnaTotalRecords
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn_laodmore",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.search(0)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t("BUTTON.SEARCH.LOAD.MORE")
                                      ) +
                                      "\n                                "
                                  ),
                                  _c("em", [
                                    _vm._v(
                                      "\n                                    ("
                                    ),
                                    _c("i", [
                                      _vm._v(_vm._s(_vm.qnaCurrentRecords))
                                    ]),
                                    _vm._v(
                                      " / " +
                                        _vm._s(_vm.qnaTotalRecords) +
                                        ")\n                                "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.getIsMobile &&
                          _vm.searchYn &&
                          ((0 === _vm.qnaTotalRecords && _vm.searchYn) ||
                            _vm.viewYn)
                            ? _c(
                                "a",
                                {
                                  staticClass: "txt_link",
                                  attrs: { href: "javascript:" },
                                  on: {
                                    click: function($event) {
                                      return _vm.register()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("MESSAGE.FAQ.CREATE")) +
                                      "\n                            "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "faq_wrap" }, [
                    _c("ul", { staticClass: "faq_list" }, [
                      _c("li", { staticClass: "nodata" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("MESSAGE.GLOBAL.NO.DATA")))
                        ])
                      ])
                    ])
                  ])
            ])
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0de3890", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0de3890","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/qna/newQuestionList.vue
// module id = X51o
// module chunks = 0